module.exports = __webpack_public_path__ + "img/banner.3a42ef03.png";